import { Component, Inject, OnInit } from '@angular/core';
import * as firebase from 'firebase/app';
import 'firebase/auth';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  user;
  env;

  constructor(private router: Router) {}

  ngOnInit() {
    firebase.auth().onAuthStateChanged(async user => {
      if (user) {
        const interv = setInterval(async () => {
          if (environment.user && environment.selected) {
            this.env = environment;
            this.user = environment.user;

            this.user.empresas.sort((a, b) => {
              if (a.fantasia > b.fantasia) {
                return 1;
              }
              if (a.fantasia < b.fantasia) {
                return -1;
              }
              return 0;
            });

            clearInterval(interv);
          }
        }, 500);
      }
    });
  }

  async setEmpresa(emp) {
    environment.selected = emp;
    const path = location.pathname.split('/');
    return await this.router.navigateByUrl(path[1] + '/' + emp.cnpj);
  }

  logout() {
    firebase.auth().signOut();
  }
}
